"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _linkItem = _interopRequireDefault(require("./link-item"));
var _functions = require("./functions");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _useSticky = require("../sticky-stack/use-sticky");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const NavContainer = /*#__PURE__*/(0, _react2.styled)("nav")({
  name: "NavContainer",
  class: "pl-n18byxmq",
  vars: {
    "n18byxmq-1": [({
      hasCta
    }) => hasCta ? 'var(--layout-rail-desktopLg)' : '0']
  }
});
const Inner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Inner",
  class: "pl-ihk6oip"
});
const ArrowUp = /*#__PURE__*/(0, _react2.styled)(_icon.Icon)({
  name: "ArrowUp",
  class: "pl-alxn6av"
});
const CtaContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaContainer",
  class: "pl-c1bj6xbs"
});
const upItem = "pl-uch5k8z";
const Links = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Links",
  class: "pl-lygn9mk",
  vars: {
    "lygn9mk-4": [({
      hideArrow
    }) => hideArrow ? '0' : _patternLibraryUtils.density['1']],
    "lygn9mk-11": [({
      hideArrow
    }) => hideArrow ? 'none' : 'static']
  }
});

/**
 * AnchorLinkNav Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Tracking Name of the Navigation Bar
 * @param {Array} props.items Items for the AnchorLinks
 * @param {Array} props.cta Navigation Button
 * @param {String} props.partial Partial Theme
 * @returns {React.ReactElement} AnchorLinkNav Component
 * @public
 */
function AnchorLinkNav({
  _name,
  items,
  cta,
  partial = 'navigate-low-contrast'
}) {
  const [activeItem, setActiveItem] = (0, _react.useState)(null);
  const ref = (0, _react.useRef)(null);
  const listRef = (0, _react.useRef)(null);
  const navRef = (0, _react.useRef)(null);
  _patternLibraryUtils.tracking.useTracking(ref);
  const ids = items?.map(item => {
    // TODO: CMS-30048: Clean up this logic to only support item.props
    const itemId = item?.targetId?.id || item?.targetId || item?.props?.target?.props?.entryId;
    if ((0, _patternLibraryUtils.isValidId)(itemId)) {
      return `id-${itemId}`;
    }
    return itemId;
  });
  const navHeight = 72;
  const activeSection = (0, _functions.useScrollDetect)(ids, navHeight * 2);
  const navWidth = (0, _patternLibraryUtils.useWidthObserver)(ref);

  // Anchor Link Nav always sticky
  (0, _useSticky.useSticky)(`anchor-link-nav`, ref, true);
  (0, _react.useEffect)(() => {
    const arr = [...(listRef?.current?.children || [])];
    const refs = arr?.filter(e => e?.dataset?.active === 'true');
    const activeElementPos = refs?.map(item => item.offsetLeft);
    const scrollOffset = 200;
    if (navWidth <= _patternLibraryUtils.size.tabletLg && activeSection !== null) {
      navRef?.current?.scrollTo({
        behavior: 'smooth',
        left: activeElementPos - scrollOffset
      });
    }
    const active = items?.slice(0, 7).filter((_, index) => ids[index] === activeSection).pop();
    if (activeSection) {
      setActiveItem(active);
    } else {
      setActiveItem(null);
    }
  }, [activeSection, navWidth, items]);
  return /*#__PURE__*/_react.default.createElement(NavContainer, (0, _extends2.default)({
    "data-partial": partial,
    ref: ref,
    "data-cy": "anchor-link-nav",
    id: "anchor-link-nav"
  }, _patternLibraryUtils.tracking.props(_name), {
    hasCta: !!cta
  }), /*#__PURE__*/_react.default.createElement(Inner, {
    "data-cy": "nav-inner",
    ref: navRef
  }, /*#__PURE__*/_react.default.createElement(Links, {
    hideArrow: false
  }, /*#__PURE__*/_react.default.createElement("ul", {
    ref: listRef,
    role: "menu"
  }, /*#__PURE__*/_react.default.createElement(_text.default.li, (0, _extends2.default)({
    as: "paragraph",
    size: -1,
    className: upItem,
    role: "menuitem",
    "aria-label": "Scroll To Top",
    tabIndex: 0,
    "data-cy": "scroll-up-link"
  }, _patternLibraryUtils.tracking.create('scroll-to-top', true, true), {
    onClick: _functions.scrollToTop
  }), /*#__PURE__*/_react.default.createElement(ArrowUp, {
    name: "arrow-up"
  })), items?.slice(0, 7)?.map((item, index) => {
    return (
      // TODO: CMS-30048: Remove this logic entirely. Should only render item as a React Node.
      /*#__PURE__*/_react.default.isValidElement(item) ? /*#__PURE__*/_react.default.cloneElement(item, {
        ...item.props,
        active: activeItem === item
      }) : /*#__PURE__*/_react.default.createElement(_linkItem.default, (0, _extends2.default)({
        active: activeItem === item,
        key: index
      }, item, {
        targetId: ids[index]
      }))
    );
  })))), navWidth >= _patternLibraryUtils.size.tablet && cta && /*#__PURE__*/_react.default.createElement(CtaContainer, {
    "data-cy": "cta-container"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: cta
  })));
}
var _default = exports.default = AnchorLinkNav;
AnchorLinkNav.propTypes = {
  _name: _propTypes.default.string,
  items: _propTypes.default.oneOf([_propTypes.default.array, _propTypes.default.arrayOf(_propTypes.default.node)]),
  cta: _propTypes.default.oneOf([_propTypes.default.arrayOf(_propTypes.default.shape(_index.default.propTypes)), _propTypes.default.arrayOf(_propTypes.default.node)]),
  partial: _propTypes.default.string
};